<app-core-offcanvas
  [headerTitle]="('organization.organization' | translate) + header"
  (closed)="onOffCanvasClosed()"
  width="100%"
  #orgCanvas
  (chooseOn)="mode === 'edit' ? update() : save()"
  [saveText]="(mode === 'edit' ? 'common.update' : 'common.save') | translate"
  [saveButtonDisable]="false"
  [showSaveButton]="(mode === 'edit' && ('organization-filter-list' | hasPermission: 'update')) || (mode != 'edit' && ('organization-filter-list' | hasPermission: 'create'))"
>
  <div class="org-container">
    <!-- Sidebar -->
    <div class="sidebar">
      <button
        class="sidebar-button"
        [class.active]="selectedTab === 'organization'"
        (click)="setTab('organization')"
      >
        <i class="la la-home sidebar-icon"></i>
        <span class="sidebar-text">{{ 'organization.organization-tab-header' | translate }}</span>
      </button>
      <!--<button
        class="sidebar-button"
        [class.active]="selectedTab === 'vehicle'"
        (click)="setTab('vehicle')"
      >
        <i class="la la-car sidebar-icon"></i>
        <span class="sidebar-text">{{ 'organization.vehicle-tab-header' | translate }}</span>
      </button>-->
      <button
        class="sidebar-button"
        [class.active]="selectedTab === 'file'"
        (click)="setTab('file')"
      >
        <i class="la la-file sidebar-icon"></i>
        <span class="sidebar-text">{{ 'organization.file-tab-header' | translate }}</span>
      </button>
    </div>

    <!-- İçerik Alanı -->
    <div class="content">
      <!-- Organizasyon Bilgileri -->
      <div [hidden]="selectedTab !== 'organization'">
        <app-create-organization-tab-one #orgCreateTabOne></app-create-organization-tab-one>
      </div>

      <!-- Araç Hareketleri -->
      <!--<div [hidden]="selectedTab !== 'vehicle'">
        <app-create-organization-tab-two #orgCreateTabTwo></app-create-organization-tab-two>
      </div>-->

      <!-- Dosya İşlemleri -->
      <div [hidden]="selectedTab !== 'file'">
        <app-create-organization-tab-three #orgCreateTabThree></app-create-organization-tab-three>
      </div>
    </div>
  </div>
</app-core-offcanvas>
